module.exports = __webpack_public_path__ + "static/media/sample_for_bulk_upload_for_transit_times.63fe211b.csv";